import React, { useState, useEffect, useMemo } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import * as todoAction from './store/Submit.action';
import List from './List';
import { Page_Size } from '../../../../Components/helper';
import SubmitFilter from './SubmitFilter';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import * as systemMasterAction from '../../../SystemMasters/Store/SystemMasters.action';

function SubmitDownload() {
  const dispatch = useDispatch();
  const submit_Download = 'submit-download';
  const { t } = useTranslation('common');

  const reducers = useSelector((redState) => redState);
  const {
    submitTodoListReducer: {
      submitListData,
      submitFilterValues: {
        searchText,
        selected_Season,
        selected_Brand,
        selected_Supplier,
        selected_Category1,
        selected_Category2,
        selected_Category3,
        selected_Category4,
        selected_Status,
        pageIndex,
        pageSize,
        selected_Send_To,
        selected_DownloadBy,
        selected_SendBy,
        selected_Submitted,
        selected_Month,
        selected_Year,
      },
      submitListTotalCount,
      submitSelectedIds,
    },
    SystemMastersDetails: { subBrandAccess },
  } = reducers;
  const [selectedColumn, setSelectedColumn] = useState([]);
  const [state, setState] = useState({
    isLoading: false,
    hasMore: false,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isExportLoading: false,
    isDownloadLoading: false,
    selectedCount: 0,
    showConfirmationPopup: false,
    removeLoader: false,
  });
  const { showConfirmationPopup, removeLoader } = state;

  useEffect(() => {
    const callFn = async () => {
      let filterd = {};
      const obj = JSON.parse(localStorage.getItem('submitTodoListFilter'));
      if (obj) {
        filterd = {
          seasons: obj.selected_Season,
          brand: obj.selected_Brand,
          supplier: obj.selected_Supplier,
          category1: obj.selected_Category1,
          category2: obj.selected_Category2,
          category3: obj.selected_Category3,
          category4: obj.selected_Category4,
          createdBy: obj.selected_CreatedBy,
          modifiedBy: obj.selected_ModifiedBy,
          status: obj.selected_Status,
          sendTo: obj.selected_Send_To,
          downloadBy: obj.selected_DownloadBy,
          sendBy: obj.selected_SendBy,
          sendBy1: obj.selected_Submitted,
          month: obj.selected_Month,
          year: obj.selected_Year,
          licensorId: obj.selectedLicensor,
          licenseId: obj.selectedLicense,
          likenessId: obj.selectedLikeness,
        };
        obj.pageIndex = 1;
        await dispatch(todoAction.filterSortData(obj));
      }
      const params = {
        pageSize,
        pageIndex: 1,
        type: submit_Download,
        ...filterd,
      };
      setState((prevState) => ({ ...prevState, isLoading: true }));
      const res = await dispatch(todoAction.getSubmitList(params));
      if (res) {
        setState((prevState) => ({
          ...prevState,
          hasMore: true,
          isLoading: false,
        }));
      }
    };
    callFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const params = {
          searchText,
          pageIndex: 1,
          pageSize: Page_Size,
          seasons: selected_Season,
          brand: selected_Brand,
          supplier: selected_Supplier,
          category1: selected_Category1,
          category2: selected_Category2,
          category3: selected_Category3,
          category4: selected_Category4,
          status: selected_Status,
          sendTo: selected_Send_To,
          downloadBy: selected_DownloadBy,
          sendBy: selected_SendBy,
          sendBy1: selected_Submitted,
          type: submit_Download,
          month: selected_Month,
          year: selected_Year,
        };
        await dispatch(todoAction.getSubmitList(params));
        setState((searchEndState) => ({
          ...searchEndState,
          isLoading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchText, dispatch]);

  useEffect(() => {
    if (submitListTotalCount > submitListData?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [submitListData?.length, submitListTotalCount]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      searchText,
      seasons: selected_Season,
      brand: selected_Brand,
      supplier: selected_Supplier,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      pageIndex: index,
      pageSize,
      totalRecords: submitListTotalCount,
      status: selected_Status,
      isScrolled: true,
      type: submit_Download,
      sendTo: selected_Send_To,
      downloadBy: selected_DownloadBy,
      sendBy: selected_SendBy,
      sendBy1: selected_Submitted,
      month: selected_Month,
      year: selected_Year,
    };

    const obj = {
      pageIndex: index,
      pageSize,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));

    await dispatch(todoAction.filterSortData(obj));
    await dispatch(todoAction.getSubmitList(params));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  const exportFiles = async (type) => {
    const params = {
      searchText,
      seasons: selected_Season,
      brand: selected_Brand,
      supplier: selected_Supplier,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      pageIndex: 1,
      pageSize: submitListTotalCount,
      type: submit_Download,
      productIds: submitSelectedIds,
      downloadType: type,
      status: selected_Status,
      sendTo: selected_Send_To,
      downloadBy: selected_DownloadBy,
      sendBy: selected_SendBy,
      sendBy1: selected_Submitted,
      month: selected_Month,
      year: selected_Year,
    };

    if (type === 'pdf') {
      setState((prevState) => ({ ...prevState, isDownloadLoading: true }));
      await dispatch(todoAction.exportToPdf(params));
      setState((prevState) => ({ ...prevState, isDownloadLoading: false }));
    } else {
      setState((prevState) => ({ ...prevState, isExportLoading: true }));
      await dispatch(todoAction.exportExcel(params));
      setState((prevState) => ({ ...prevState, isExportLoading: false }));
    }
  };
  const getCount = (selectedCnt) => {
    setState((prevState) => ({
      ...prevState,
      selectedCount: selectedCnt.length,
    }));
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
    };
    await dispatch(todoAction.filterSortData(obj));
  };

  const baseMappedArray = [
    { label: 'Product Description', display: 'description', value: 1 },
    { label: 'Supplier', display: 'supplier', value: 2 },
    { label: 'Brand', display: 'brandId', value: 3 },
    { label: 'Season', display: 'seasonId', value: 4 },
    { label: 'Month', display: 'month', value: 5 },
    { label: 'Year', display: 'year', value: 6 },
    { label: 'Category 1', display: 'catOneId', value: 7 },
    { label: 'Category 2', display: 'catTwoId', value: 8 },
    { label: 'Category 3', display: 'catThreeId', value: 9 },
    { label: 'Category 4', display: 'catFourId', value: 10 },
  ];

  const mappedArray = useMemo(() => {
    const array = [...baseMappedArray];
    if (subBrandAccess) {
      array.push({ label: 'Sub Brand', display: 'subBrandId', value: 11 });
    }
    return array;
  }, [subBrandAccess]);

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      await dispatch(systemMasterAction.getSubBrandAccess());
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  const handleSelectChange = (selected) => {
    setSelectedColumn([...selected]);
  };

  const renderSelection = () => {
    const emptySentence = isEmpty(selectedColumn) ? t('PROGRESS_INDICATOR.SELECT_COLUMN') : `${selectedColumn?.length} Columns Selected`;
    return selectedColumn?.length === mappedArray?.length ? t('PROGRESS_INDICATOR.ALL_SELECTED') : emptySentence;
  };

  const removeSubmitDataFromList = async () => {
    setState((prev) => ({
      ...prev,
      removeLoader: true,
    }));
    const params = {
      searchText,
      month: selected_Month,
      year: selected_Year,
      seasons: selected_Season,
      brand: selected_Brand,
      supplier: selected_Supplier,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      status: selected_Status,
      sendTo: selected_Send_To,
      downloadBy: selected_DownloadBy,
      sendBy: selected_SendBy,
      sendBy1: selected_Submitted,
      pageIndex: 1,
      pageSize: Page_Size,
      type: submit_Download,
      submitSelectedIds,
    };
    await dispatch(todoAction.removeSubmitDataFromListAction(params));
    await dispatch(todoAction.getSubmitList(params));
    setState((prev) => ({
      ...prev,
      removeLoader: false,
      showConfirmationPopup: false,
    }));
  };

  useEffect(() => {
    return () => {
      const obj = {
        searchText: '',
      };
      dispatch(todoAction.filterSortData(obj));
    };
  }, [dispatch]);
  return (
    <>
      <div>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <h4 className="title">{t('REPORTS.SUBMISSION_DOWNLOAD_TO_DO')}</h4>
          </div>
          <div className="search-filter">
            {submitSelectedIds && submitSelectedIds?.length > 0 && (
              <span className="d-none d-md-inline-block txt-selected-cnt">
                {submitSelectedIds?.length} {t('COSTING_TO_DO_LIST.RECORD_SELECTED')}
              </span>
            )}
            {submitListTotalCount > 0 && (
              <span className="d-none d-md-inline-block txt-selected-cnt">
                {submitListTotalCount} {t('COSTING_TO_DO_LIST.TOTAL_RECORDS')}
              </span>
            )}
            <div className="mobile-multi-search">
              {/* title-search-container */}
              <div className="custom-multiselect ">
                <MultiSelect
                  name="attributes"
                  options={mappedArray}
                  className="custom-multiselect-PO"
                  value={selectedColumn}
                  valueRenderer={renderSelection}
                  labelledBy={t('TAKING_DATES.SELECT_ATTRIBUTE')}
                  onChange={handleSelectChange}
                />
              </div>
              <SearchBar placeholder={t('TAKING_DATES.SERCH')} onSearch={handleSearch} value={searchText} />
            </div>
            <div className="mobile-btns">
              <SubmitFilter />
              <button
                type="button"
                disabled={isEmpty(submitSelectedIds)}
                onClick={() =>
                  setState((prev) => ({
                    ...prev,
                    showConfirmationPopup: true,
                  }))
                }
                className="filter-btn filter-button_delete"
                title={t('TAKING_DATES.REMOVE_LOG')}
                aria-label={t('TAKING_DATES.REMOVE_LOG')}
              >
                <i className="icon-cancel" />
              </button>
              <Dropdown className="supplier-more-option">
                <Dropdown.Toggle disabled={submitListData.length < 1}>
                  <button
                    className="filter-btn filter-button_delete"
                    type="button"
                    title={t('COSTING_TO_DO_LIST.EXPORT_EXCEL')}
                    aria-label={t('COSTING_TO_DO_LIST.EXPORT_EXCEL')}
                  >
                    <i title={t('PROGRESS_INDICATOR.DOWNLOAD_EXCEL')} className="icon-download" />
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <a className={state.isDownloadLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'} href={() => false} onClick={() => exportFiles('pdf')}>
                    {state.isDownloadLoading ? t('PROGRESS_INDICATOR.DOWNLOADING') : t('PROGRESS_INDICATOR.DOWNLOAD_PDF')}
                  </a>
                  <a className={state.isExportLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'} href={() => false} onClick={() => exportFiles('excel')}>
                    {state.isExportLoading ? t('PROGRESS_INDICATOR.EXPORTING') : t('PROGRESS_INDICATOR.EXPORT_EXCEL')}
                  </a>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="scrollableDiv"
            style={{
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={submitListData.length}
              hasMore={state.hasMore}
              next={() => handlePageNextInScroll()}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
            >
              <List loading={state.isLoading} getSelectedCount={getCount} mappedArray={selectedColumn} />
            </InfiniteScroll>
          </div>
        </div>
      </div>

      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={removeSubmitDataFromList}
          loading={removeLoader}
          title={t('TAKING_DATES.REMOVE_LOG')}
          message={t('TAKING_DATES.WANT_REMOVE_LOGS')}
          toggle={() =>
            setState((prev) => ({
              ...prev,
              showConfirmationPopup: false,
            }))
          }
        />
      )}
    </>
  );
}

export default SubmitDownload;
